import { defineStore } from "pinia";
import mushroom from "cem-probe-api";
import { getSystemTypeFilter } from "@/utils/systemType";

export const ListDashboardPopup = defineStore({
  id: "listDashboardPopup",
  state: () => ({
    data: [],
  }),
  actions: {
    async getAllListDashboardPopup() {
      const filter = getSystemTypeFilter();
      mushroom.dashboard_popup.invalidCache();
      try {
        const response = await mushroom.dashboard_popup.getAllAsync({
          filters: filter.build(),
        });
        if (response.result) {
          this.data = response.result;
        }
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
  },
  getters: {
    showListDashboardPopup: (state) => {
      return state.data;
    },
  },
});
